import {SET_INTERACTION_DATA,SET_ACTIVITY_INTERACTION_DATA,SET_SELECTED_INTERACTION_DATA, GET_SHOP_SITE_DATA, GET_BRAND_SHOPIFY,SET_SHOPIFY_ALL_DATA,SET_SHOP_COM_ALL_DATA, GET_PRODUCT_DETAILS, GET_PRODUCT_DETAIL, GET_PRODUCTS_IN_CART, CLEAR_PRODUCT_DATA, SET_PRODUCT_DETAILS_LOADING} from './interaction.actiontypes'


export function setInteractionData(data:any): any {
    return (dispatch: any) => {
        dispatch({
            type: SET_INTERACTION_DATA,
            payload:data
        });
    }
}

export function setActivityInteractionData(data:any): any {
    return (dispatch: any) => {
        dispatch({
            type: SET_ACTIVITY_INTERACTION_DATA,
            payload:data
        });
    }
}

export function setSelectedInteractionData(data:any): any {
    return (dispatch: any) => {
        dispatch({
            type: SET_SELECTED_INTERACTION_DATA,
            payload:data
        });
    }
}

export function getShopSiteData(data:any): any {
    return (dispatch: any) => {
        dispatch({
            type: GET_SHOP_SITE_DATA,
            payload:data
        });
    }
}

export function getBrandShopify(data:any): any {
    return (dispatch: any) => {
        dispatch({
            type: GET_BRAND_SHOPIFY,
            payload:data
        });
    }
}


export function setShopifyAllData(data:any): any {
    return (dispatch: any) => {
        dispatch({
            type: SET_SHOPIFY_ALL_DATA,
            payload:data
        });
    }
}


export function setShopComAllData(data:any): any {
    return (dispatch: any) => {
        dispatch({
            type: SET_SHOP_COM_ALL_DATA,
            payload:data
        });
    }
}

export function getProductDetails(data:any): any {
    return (dispatch: any) => {
        dispatch({
            type: GET_PRODUCT_DETAILS,
            payload:data
        });
    }
}

export function getProductDetail(data:any): any {
    return (dispatch: any) => {
        dispatch({
            type: GET_PRODUCT_DETAIL,
            payload:data
        });
    }
}

export function setProductsInCart(data:any): any {
    return (dispatch: any) => {
        dispatch({
            type: GET_PRODUCTS_IN_CART,
            payload:data
        });
    }
}

export function clearProductData(): any {
    return (dispatch: any) => {
        dispatch({
            type: CLEAR_PRODUCT_DATA
        });
    }
}

export function setProductDetailsLoading(isLoading: boolean): any {
    return (dispatch: any) => {
        dispatch({
            type: SET_PRODUCT_DETAILS_LOADING,
            payload: isLoading
        });
    }
}